import { defineMessages } from 'react-intl'

export const scope = 'app.components.VCheckReviewTable'

/*
 * VCheckReviewTable Messages
 *
 * This contains all the text for the VCheckReviewTable component.
 */
export default defineMessages({
  loading: {
    id: `${scope}.loading`,
    defaultMessage: 'Loading Event Data...',
  },
  tableHeaderOne: {
    id: `${scope}.tableHeaderOne`,
    defaultMessage: 'Client Name',
  },
  tableHeaderTwo: {
    id: `${scope}.tableHeaderTwo`,
    defaultMessage: 'Agency Name',
  },
  tableHeaderThree: {
    id: `${scope}.tableHeaderThree`,
    defaultMessage: 'Event Type',
  },
  tableHeaderFour: {
    id: `${scope}.tableHeaderFour`,
    defaultMessage: 'Brac Result',
  },
  tableHeaderFive: {
    id: `${scope}.tableHeaderFive`,
    defaultMessage: 'Created',
  },
  tableHeaderSix: {
    id: `${scope}.tableHeaderSix`,
    defaultMessage: 'Location',
  },
  tableHeaderSeven: {
    id: `${scope}.tableHeaderSeven`,
    defaultMessage: 'Status',
  },
  tableHeaderEight: {
    id: `${scope}.tableHeaderEight`,
    defaultMessage: 'Facial Rec Status',
  },
  tableHeaderNine: {
    id: `${scope}.tableHeaderNine`,
    defaultMessage: 'Serial Number',
  },
})
